export type OutputType = 'csv' | 'excel';

export interface FileNamePart {
  partType: PartType;
  value?: string;
}

export interface FileNameSettings {
  outputType: OutputType;
  name: FileNamePart[];
}

export enum PartType {
  QueryName = 'Query name',
  ReportName = 'Schedule title',
  Year = 'Year',
  Month = 'Month',
  Day = 'Day',
  Timestamp = 'Timestamp',
  Weekday = 'Weekday',
  Custom = 'Custom',
}

export class FileNameUtils {
  public static GetPartOptionName(part: FileNamePart): string {
    if (part.partType === PartType.Custom) {
      return part.value || '';
    } else return part.partType;
  }

  public static ExtensionForType: (type: OutputType) => string = (
    type: OutputType
  ) => {
    return type === 'excel' ? '.xlsm' : '.csv';
  };

  public static ComposeFileName = (
    settings: FileNameSettings,
    scheduleTitle: string,
    queryName: string
  ): string => {
    if (!settings.name || settings.name.length === 0) {
      return '';
    }
    const today = new Date();
    const stringParts = settings.name.map(part =>
      FileNameUtils.FilePartToString(part, scheduleTitle, queryName, today)
    );

    let result = '';
    for (let i = 0; i < settings.name.length; i++) {
      if (i === 0) {
        result = result.concat(stringParts[i]);
      } else {
        if (
          FileNameUtils.isDatePart(settings.name[i]) &&
          FileNameUtils.isDatePart(settings.name[i - 1])
        ) {
          result = result.concat('-', stringParts[i]);
        } else {
          result = result.concat('_', stringParts[i]);
        }
      }
    }

    return result.concat(FileNameUtils.ExtensionForType(settings.outputType));
  };

  public static FilePartToString = (
    part: FileNamePart,
    reportName: string,
    queryName: string,
    date: Date
  ): string => {
    switch (part.partType) {
      case PartType.Day:
        return FileNameUtils.zeroFill(date.getDate(), 2);
      case PartType.Month:
        return FileNameUtils.zeroFill(date.getMonth() + 1, 2);
      case PartType.Year:
        return date.getFullYear().toString();
      case PartType.Timestamp:
        return 'T' + date.getHours() + '-' + date.getMinutes();
      case PartType.Weekday:
        return date.toLocaleString('en-us', { weekday: 'long' });
      case PartType.ReportName:
        return reportName;
      case PartType.QueryName:
        return queryName;
      default:
        return part.value || '';
    }
  };

  private static isDatePart = (part: FileNamePart): boolean => {
    return (
      part.partType === PartType.Day ||
      part.partType === PartType.Year ||
      part.partType === PartType.Month
    );
  };

  static zeroFill(n: number, size: number): string {
    let num = n.toString();
    while (num.length < size) num = '0' + n;
    return num;
  }
}

export const ForbiddenCharacters = [
  '\\',
  '#',
  '$',
  '%',
  '^',
  '/',
  ':',
  '*',
  '?',
  '!',
  '`',
  '>',
  '<',
  '|',
];

export const ForbiddenCharactersPattern =
  /[!@#$%^&*+\-=\x5B\x5D{};':"\\|,.<>\x2F?]+/;
